import 'reflect-metadata';

export const ATTRIBUTE_PREFIX = 'attribute:';

export const ATTRIBUTE_FIELDNAME = 'fieldName';
export const ATTRIBUTE_TTPE = 'fieldType';

interface IAttributeProperties {
  fieldName?: string;
  fieldType?: string;
  updatable?: boolean;
}

/**
 * Añade atributos de metadata a una propiedad
 * @param {IAttributeProperties} attributes
 * @returns {(target: any, propertyKey: string) => void}
 * @constructor
 */
export function ModelAttribute(attributes: IAttributeProperties) {
  return (target: object, propertyKey: string) => {
    if (attributes !== undefined && attributes !== null) {
      Object.keys(attributes).forEach(key => {
        Reflect.defineMetadata(`${ATTRIBUTE_PREFIX}${key}`, attributes[key], target, propertyKey);
      });
    }
  };
}
